// extracted by css-extract-rspack-plugin
export default {"issueFound":"jhxwkEiHD6cGwskW","passing":"cJUkSJlYU48p92ZK","needConfiguration":"ICvTBrCBn20f_iws"};